import DataTableRow from './data_table_row';

export default class DataTableRowManagement{
  constructor(rowBuilder){
    this.rowBuilder  = rowBuilder;
    this.dataTableRows = [];
  }

  build(rowData, parsingErrors){
    let cellsRow = this.rowBuilder.build(rowData, parsingErrors);

    this.dataTableRows.push(new DataTableRow(cellsRow));
  }

  rebuild(rowData, index){
    let cellsRow = this.rowBuilder.build(rowData, []);

    this.dataTableRows[index] = new DataTableRow(cellsRow);
  }

  renderRows(){
    return this.dataTableRows.map((row) => row.render());
  }

  parsedCsvContent(){
    let csvContent = this.dataTableRows.map((tableRow) => tableRow.csvRow() + '\n');

    csvContent.unshift(this.rowBuilder.columns.join(';') + '\n');

    return csvContent;
  }

  clean(){
    this.dataTableRows = [];
  }
}
